import React from "react";
import { useAppContext } from "../../context";
import { isPME_TEAM } from "../../helper";
import { WrapperPage } from "../../components/shared/WrapperPage";
import AmazonIdeaTemplate from "../../components/amazon-idea-template";

export default function AmazonIdeaTemplatePage() {
    const { currentUser } = useAppContext();
    const isPME = isPME_TEAM(currentUser);

    return (
        <WrapperPage>
            {isPME ? (
                <AmazonIdeaTemplate />
            ) : (
                <p>You don't have privilege to access this route</p>
            )}
        </WrapperPage>
    );
}
